import { jsx as l } from "react/jsx-runtime";
import t from "./roche-control-group.module.scss.js";
const s = ({ ariaLabel: o, children: r }) => /* @__PURE__ */ l("div", { className: t["control-group"], role: "group", "aria-label": o, children: r });
export {
  s as RocheUIControlGroup
};
